module.exports = __webpack_public_path__ + "media/images/countrysquared/sb-347830c7dbf5b79d17e0fbcf668c67a0.svg";